var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.filteredItems),function(item){return _c('Package',{key:item.name,attrs:{"item":item,"selected":_vm.selected,"selectedClass":_vm.selectedClass}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }